import { TOGGLE_SCHEDULE_SIDEBAR } from '@/store/action-types';

export function toggleSidebar() {
  return dispatch => {
    return dispatch({
      type: TOGGLE_SCHEDULE_SIDEBAR,
    });
  };
}
